
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.default || mod) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
  }
}
import { default as _91_46_46_46slug_93VDjWqA1e2tMeta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105104241Z/pages/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93OTJLkjLnCIMeta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105104241Z/pages/blogg/[...slug].vue?macro=true";
import { default as indexyEZDPIhOzlMeta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105104241Z/pages/blogg/index.vue?macro=true";
import { default as indexWRYM3BqgFyMeta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105104241Z/pages/checkout/index.vue?macro=true";
import { default as payment2Ivl8I82yrMeta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105104241Z/pages/checkout/payment.vue?macro=true";
import { default as index_46client17llHJ2JOSMeta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105104241Z/pages/checkout/thank-you/index.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/var/www/projects/nuxt.hillceramic.no/releases/20261105104241Z/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as indexcmCN7UPwWRMeta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105104241Z/pages/collections/index.vue?macro=true";
import { default as _91slug_936GGJ1dMTcmMeta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105104241Z/pages/faq/[slug].vue?macro=true";
import { default as indexEhJABW9nVLMeta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105104241Z/pages/hillceramic-rabattkoder/index.vue?macro=true";
import { default as indexAkZ67OqJDUMeta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105104241Z/pages/index.vue?macro=true";
import { default as indexYiTeLcwWgzMeta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105104241Z/pages/login/index.vue?macro=true";
import { default as _91id_93LAdrfDGErPMeta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105104241Z/pages/qr-pr/[id].vue?macro=true";
import { default as formzpuRiuv63VMeta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105104241Z/pages/review/form.vue?macro=true";
import { default as indexNqUfSBq5lXMeta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105104241Z/pages/review/index.vue?macro=true";
import { default as _91_46_46_46slug_93FAaoUtywd9Meta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105104241Z/pages/shop/[...slug].vue?macro=true";
import { default as indexAhMxvndpOsMeta } from "/var/www/projects/nuxt.hillceramic.no/releases/20261105104241Z/pages/track/index.vue?macro=true";
export default [
  {
    name: "slug___no",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93VDjWqA1e2tMeta || {},
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105104241Z/pages/[...slug].vue")
  },
  {
    name: "blogg-slug___no",
    path: "/blogg/:slug(.*)*",
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105104241Z/pages/blogg/[...slug].vue")
  },
  {
    name: "blogg___no",
    path: "/blogg",
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105104241Z/pages/blogg/index.vue")
  },
  {
    name: "checkout___no",
    path: "/checkout",
    meta: indexWRYM3BqgFyMeta || {},
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105104241Z/pages/checkout/index.vue")
  },
  {
    name: "checkout-payment___no",
    path: "/checkout/payment",
    meta: payment2Ivl8I82yrMeta || {},
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105104241Z/pages/checkout/payment.vue")
  },
  {
    name: "checkout-thank-you___no",
    path: "/checkout/thank-you",
    meta: index_46client17llHJ2JOSMeta || {},
    component: () => createClientPage(() => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105104241Z/pages/checkout/thank-you/index.client.vue"))
  },
  {
    name: "collections___no",
    path: "/kolleksjoner",
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105104241Z/pages/collections/index.vue")
  },
  {
    name: "faq-slug___no",
    path: "/faq/:slug()",
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105104241Z/pages/faq/[slug].vue")
  },
  {
    name: "hillceramic-rabattkoder___no",
    path: "/hillceramic-rabattkoder",
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105104241Z/pages/hillceramic-rabattkoder/index.vue")
  },
  {
    name: "index___no",
    path: "/",
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105104241Z/pages/index.vue")
  },
  {
    name: "login___no",
    path: "/login",
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105104241Z/pages/login/index.vue")
  },
  {
    name: "qr-pr-id___no",
    path: "/qr-pr/:id()",
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105104241Z/pages/qr-pr/[id].vue")
  },
  {
    name: "review-form___no",
    path: "/review/form",
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105104241Z/pages/review/form.vue")
  },
  {
    name: "review___no",
    path: "/review",
    meta: indexNqUfSBq5lXMeta || {},
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105104241Z/pages/review/index.vue")
  },
  {
    name: "shop-slug___no",
    path: "/shop/:slug(.*)*",
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105104241Z/pages/shop/[...slug].vue")
  },
  {
    name: "track___no",
    path: "/track",
    meta: indexAhMxvndpOsMeta || {},
    component: () => import("/var/www/projects/nuxt.hillceramic.no/releases/20261105104241Z/pages/track/index.vue")
  }
]